const INITIAL_STATE = {
  data: {},
  errors: {},
}
	
const calculatePriceForPrepay = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CLEAN_PREPAYMENT_RESPONSE':
    return {...state, ...INITIAL_STATE}
  case 'PREPAY_CREATED_SUCCESSFULY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'PREPAY_CREATED_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
	
export default calculatePriceForPrepay;
	